import styled from 'styled-components';

export const PreviewRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.grey[50]};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;

export const SummaryLine = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const SummaryTotal = styled.span`
  font-weight: 600;
`;

export const SummaryJoining = styled.span`
  color: ${({ theme }) => theme.palette.success.dark};
`;

export const SummaryLeaving = styled.span`
  color: ${({ theme }) => theme.palette.warning.dark};
`;

export const SummarySeparator = styled.span`
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const PreviewMessage = styled.div`
  padding: ${({ theme }) => theme.spacing(1)} 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
`;

export const PreviewPlaceholder = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.grey[50]};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};

  svg {
    font-size: 18px;
    color: ${({ theme }) => theme.palette.info.dark};
  }
`;

export const PreviewErrorBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
`;

export const RetryButton = styled.button`
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.palette.info.main};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
`;

export const MemberNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
